import {useSelector} from 'react-redux';
import {
  Button,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Chip,
  styled,
} from '@mui/material';

const DisalbedTextField = styled(TextField)({
  textFillColor: 'rgba(0, 0, 0, .9)',
  '& input': {
    textFillColor: 'rgba(0, 0, 0, 1)!important',
  },
  '& textarea': {
    textFillColor: 'rgba(0, 0, 0, 1)!important',
  },
});

const BoardContentModal = ({
  data,
  open,
  boardId,
  closeModal,
  onDownloadFile,
}) => {
  const {
    boardLists,
  } = useSelector(store => store.board)

  return (
    <Dialog
      open={open}
      onClose={closeModal}
      fullWidth={true}
      maxWidth={'md'}
    >
      <DialogTitle>
        {boardLists[boardId]?.name}
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Stack spacing={3} sx={{mb: 3}}>
          <DisalbedTextField 
            label="제목" 
            variant="outlined" 
            size="small" 
            defaultValue={data.title}
            disabled
          />

          <DisalbedTextField 
            label="내용" 
            variant="outlined" 
            size="small" 
            multiline
            minRows={4}
            maxRows={10}
            defaultValue={data.content}
            disabled
          />
        </Stack>

        {
          data.boardAttachResList.map((file, index) => {
            return (
              <Chip 
                label={file.name} 
                key={index} 
                sx={{ml: .5, mb: .5}}
                onClick={(e) => onDownloadFile(e, file)}
              />
            )
          })
        }
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button onClick={closeModal}>닫기</Button>
      </DialogActions>
    </Dialog>
  );
}

export default BoardContentModal;